import {jwtDecode} from "jwt-decode";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useTokenValidation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // debugger;
    const data = JSON.parse(localStorage.getItem("data"));
    const token = data.token;

    if (!token) {
      navigate("/mslogin");
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decoded.exp < currentTime) {
        localStorage.clear();
        navigate("/mslogin");
      }
    } catch (error) {
      console.error("Token validation error:", error);
      localStorage.clear();
      navigate("/mslogin");
    }
  }, [navigate]);
};

export default useTokenValidation;